import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useActionButtons = (
  selectedIds: string[],
  setMergeModalOpen: (open: boolean) => void
) => {
  const [openFilters, setOpenFilters] = useState(false);
  const navigate = useNavigate();

  const actionButtonsConfig = [
    {
      label: "Merge",
      icon: "ArrowRightIcon",
      base: "primary",
      onClick: () => setMergeModalOpen(true),
      disabled: selectedIds.length < 2 || selectedIds.length > 10,
      title:
        selectedIds.length < 2
          ? "Minimum 2 providers must be selected to merge"
          : selectedIds.length > 10
          ? "Maximum 10 providers can be merged at once"
          : undefined,
      btnContainerClasses:
        selectedIds.length > 0 ? "box-border" : "hidden pointer-events-none",
    },
    {
      label: "Filters",
      icon: "AdjustmentsVerticalIcon",
      base: "secondary",
      onClick: () => setOpenFilters(true),
      btnContainerClasses:
        "box-border border-2 border-primary-400 border-solid",
    },
    {
      label: "Add New",
      icon: "PlusIcon",
      onClick: () => navigate("/admin/medical-providers/new"),
      btnContainerClasses: "box-border min-w-[8rem]",
    },
  ];

  return { openFilters, setOpenFilters, actionButtonsConfig };
};
